import React, { useEffect, useMemo, useState } from "react";
import {
  Empty,
  Tag,
  Typography,
  Row,
  Col,
  Spin,
  Select,
  notification,
  Tooltip,
  Descriptions,
  Divider,
} from "antd";

import {
  LockOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  HistoryOutlined,
  CrownOutlined,
  ArrowRightOutlined,
  AimOutlined,
  CheckOutlined,
} from "@ant-design/icons";

import {
  useAssignStrategyMutation,
  useGetAllStrategyQuery,
} from "../../slices/strategyApiSlice";




import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useTradelogsMutation } from "../../slices/zerodhaApiSlice";
import { setTradelogs } from "../../slices/tradelogsSlice";
import "../css/tradeGlassLog.css"
import {
  GlassCard,
  GlassButton,
  GlassModal,
} from "../../glass";

const { Text, Title } = Typography;
const FREE_TRADE_LIMIT = 6;

const formatCurrency = (value) => {
  const amount = Number(
    value && typeof value === "object"
      ? value.$numberDecimal ?? 0
      : value ?? 0
  );

  if (!Number.isFinite(amount)) return "₹ 0.00";

  return `₹ ${amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const TradeLogsTradeTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { date } = useSelector((state) => state.date);
  const { tradelogs } = useSelector((state) => state.tradelogs);

  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const [tradeDetailsOpen, setTradeDetailsOpen] = useState(false);
const [selectedDetailTrade, setSelectedDetailTrade] = useState(null);

const openTradeDetails = (trade) => {
  setSelectedDetailTrade(trade);
  setTradeDetailsOpen(true);
};

  const [tradeLogs, { isLoading }] = useTradelogsMutation();

  const trades = useMemo(
    () =>
      Array.isArray(tradelogs?.trades)
        ? tradelogs.trades
        : [],
    [tradelogs?.trades]
  );

  const visibleTrades = trades.slice(0, FREE_TRADE_LIMIT);
  const lockedCount = Math.max(0, trades.length - FREE_TRADE_LIMIT);

  useEffect(() => {
    const fetchTrades = async () => {
      try {
        const result = await tradeLogs({
          startDate: date.startDate,
          endDate: date.endDate,
        }).unwrap();

        dispatch(setTradelogs({ ...result }));
      } catch (error) {
        console.error("Failed to load trade logs:", error);
      }
    };

    fetchTrades();
  }, [date.startDate, date.endDate, tradeLogs, dispatch]);

  const handleUpgrade = () => {
    setUpgradeOpen(false);
    navigate("/main/packages");
  };


  
const [strategyOpen, setStrategyOpen] = useState(false);
const [selectedTrade, setSelectedTrade] = useState(null);
const [selectedStrategy, setSelectedStrategy] = useState(undefined);

const [api, contextHolder] = notification.useNotification();

const { data: strategies = [], isLoading: strategiesLoading } =
  useGetAllStrategyQuery();

const [assignStrategy, { isLoading: assigningStrategy }] =
  useAssignStrategyMutation();

const strategyOptions = (strategies?.data || []).map((strategy) => ({
  value: strategy.id ?? strategy._id,
  label: strategy.name,
}));

const openAssignStrategy = (trade) => {
  setSelectedTrade(trade);
  setSelectedStrategy(
    trade.strategy_id ? String(trade.strategy_id) : undefined
  );
  setStrategyOpen(true);
};

const handleAssignStrategy = async () => {
  if (!selectedTrade?._id || !selectedStrategy) {
    api.warning({ message: "Please select a strategy" });
    return;
  }

  try {
    await assignStrategy({
      trade_id: selectedTrade._id,
      strategy_id: selectedStrategy,
    }).unwrap();

    api.success({ message: "Strategy assigned successfully" });
    setStrategyOpen(false);
    setSelectedTrade(null);
    setSelectedStrategy(undefined);
  } catch (error) {
    api.error({
      message:
        error?.data?.message ||
        error?.data?.error ||
        "Failed to assign strategy",
    });
  }
};

  return (
    <div className="trade-glass-page">
      {/* HEADER */}
      <div className="trade-glass-heading">
        <div>
          <Title level={3} className="trade-glass-title">
            Trade Log
          </Title>

          <Text className="trade-glass-subtitle">
            {trades.length} trades in your history
          </Text>
        </div>

        {/* <GlassButton
          title="Log Trade"
          icon="plus"
          onClick={() => navigate("/main/trade-log")}
        /> */}
      </div>

      {/* TRADE HISTORY */}
      {isLoading ? (
        <div className="trade-glass-loading">
          <Spin />
        </div>
      ) : trades.length === 0 ? (
        <GlassCard>
          <Empty description="No trades found" />
        </GlassCard>
      ) : (
        <>
          <Row gutter={[12, 12]}>
            {visibleTrades.map((trade, index) => {
              const profit = Number(
                trade.profit?.$numberDecimal ??
                trade.profit ??
                0
              );

              const isProfit = profit >= 0;

              return (
                <Col xs={24} lg={12} key={trade._id || index}>
                  <GlassCard>
                      <div
    onClick={() => openTradeDetails(trade)}
    style={{ cursor: "pointer" }}
  >
<div className="trade-card-top">
  <div className="trade-symbol-wrap">
    <Text className="trade-symbol">
      {trade.symbol || "Unknown"}
    </Text>

    <Tag
      className={
        trade.trade_type?.toLowerCase() === "buy"
          ? "trade-type-buy"
          : "trade-type-sell"
      }
    >
      {trade.trade_type?.toUpperCase() || "TRADE"}
    </Tag>
  </div>

  <div className="trade-card-actions">
    <Text
      className={`trade-profit ${
        isProfit ? "profit-positive" : "profit-negative"
      }`}
    >
      {isProfit ? <ArrowUpOutlined /> : <ArrowDownOutlined />}{" "}
      {formatCurrency(trade.profit)}
    </Text>

    <Tooltip title="Assign Strategy">
      <button
        type="button"
        className="trade-assign-icon"
        aria-label={`Assign strategy to ${trade.symbol || "trade"}`}
        onClick={() => openAssignStrategy(trade)}
      >
        <AimOutlined />
      </button>
    </Tooltip>
  </div>
</div>
                    {/* <div className="trade-card-top">
                      <div className="trade-symbol-wrap">
                        <Text className="trade-symbol">
                          {trade.symbol || "Unknown"}
                        </Text>

                        <Tag
                          className={
                            trade.trade_type?.toLowerCase() === "buy"
                              ? "trade-type-buy"
                              : "trade-type-sell"
                          }
                        >
                          {trade.trade_type?.toUpperCase() || "TRADE"}
                        </Tag>
                      </div>

                      <Text
                        className={
                          `trade-profit ${
                            isProfit
                              ? "profit-positive"
                              : "profit-negative"
                          }`
                        }
                      >
                        {isProfit
                          ? <ArrowUpOutlined />
                          : <ArrowDownOutlined />}{" "}
                        {formatCurrency(trade.profit)}
                      </Text>
                    </div> */}

                    <div className="trade-card-bottom">
                      <Text className="trade-date">
                        {trade.opening_date
                          ? moment.utc(trade.opening_date).format("YYYY-MM-DD")
                          : "Date unavailable"}
                      </Text>

                      <Text className="trade-meta">
                        {trade.segment || "N/A"}
                        {" · "}
                        Qty {trade.quantity ?? "—"}
                      </Text>
                    </div>
                    </div>
                  </GlassCard>
                </Col>
              );
            })}
          </Row>

          {/* LOCKED HISTORY */}
          {lockedCount > 0 && (
            <div
              className="trade-locked-card"
              role="button"
              tabIndex={0}
              onClick={() => setUpgradeOpen(true)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setUpgradeOpen(true);
                }
              }}
            >
              <div className="trade-lock-icon">
                <LockOutlined />
              </div>

              <div className="trade-locked-copy">
                <Text className="trade-locked-title">
                  {lockedCount} more trades in your history
                </Text>

                <Text className="trade-locked-description">
                  Unlock your complete trade history
                </Text>
              </div>

              <ArrowRightOutlined className="trade-locked-arrow" />
            </div>
          )}
        </>
      )}

      {/* UPGRADE MODAL */}
      <GlassModal
        open={upgradeOpen}
        onClose={() => setUpgradeOpen(false)}
        title="Upgrade Your Plan"
      >
        <div className="trade-upgrade-content">
          <div className="trade-upgrade-crown">
            <CrownOutlined />
          </div>

          <Title level={3} className="trade-upgrade-title">
            Unlock Your Trading History
          </Title>

          <Text className="trade-upgrade-description">
            Upgrade your subscription to access your complete trade
            history and review your trading performance.
          </Text>

          <div className="trade-upgrade-benefit">
            <LockOutlined />
            <span>Access your complete trade history</span>
          </div>

          <div className="trade-upgrade-benefit">
            <HistoryOutlined />
            <span>Review previous trades and performance</span>
          </div>

          <GlassButton
            title="Upgrade Plan"
            icon="arrow-right"
            onClick={handleUpgrade}
          />

          <div style={{ marginTop: 12 }}>
            <GlassButton
              title="Maybe Later"
              onClick={() => setUpgradeOpen(false)}
            />
          </div>
        </div>
      </GlassModal>
      
<GlassModal
  open={strategyOpen}
  onClose={() => setStrategyOpen(false)}
  title="Assign Strategy"
>
  <div className="trade-strategy-content">
    <Text className="trade-strategy-description">
      Assign a strategy to{" "}
      <strong>{selectedTrade?.symbol || "this trade"}</strong>
    </Text>

    <label className="trade-strategy-label">
      Select Strategy
    </label>

    <Select
      className="trade-strategy-select"
      placeholder="Choose a strategy"
      options={strategyOptions}
      value={selectedStrategy}
      onChange={setSelectedStrategy}
      loading={strategiesLoading}
      disabled={strategiesLoading || strategyOptions.length === 0}
      showSearch
      optionFilterProp="label"
      style={{ width: "100%" }}
      notFoundContent={
        strategiesLoading ? <Spin size="small" /> : "No strategies found"
      }
    />

    {!strategiesLoading && strategyOptions.length === 0 && (
      <Text className="trade-strategy-description">
        No strategies available. Create a strategy first.
      </Text>
    )}

    {/* <div className="trade-strategy-buttons">
      <GlassButton
        title="Cancel"
        onClick={() => setStrategyOpen(false)}
      />

      <GlassButton
        title={assigningStrategy ? "Assigning..." : "Assign Strategy"}
        icon="check"
        onClick={handleAssignStrategy}
        disabled={!selectedStrategy || assigningStrategy}
      />
    </div> */}
    
<div className="trade-strategy-buttons">
  <button
    type="button"
    className="trade-strategy-btn trade-strategy-cancel"
    onClick={() => setStrategyOpen(false)}
  >
    Cancel
  </button>

  <button
    type="button"
    className="trade-strategy-btn trade-strategy-assign"
    onClick={handleAssignStrategy}
    disabled={!selectedStrategy || assigningStrategy}
  >
    {assigningStrategy ? "Assigning..." : "Assign Strategy"}
  </button>
</div>
  </div>
</GlassModal>
<GlassModal
  open={tradeDetailsOpen}
  onClose={() => {
    setTradeDetailsOpen(false);
    setSelectedDetailTrade(null);
  }}
  title="Trade Details"
>
  {selectedDetailTrade && (
    <div className="trade-strategy-content">
      <div className="trade-card-top">
        <div className="trade-symbol-wrap">
          <Text className="trade-symbol">
            {selectedDetailTrade.symbol || "Unknown"}
          </Text>

          <Tag
            className={
              selectedDetailTrade.trade_type?.toLowerCase() === "buy"
                ? "trade-type-buy"
                : "trade-type-sell"
            }
          >
            {selectedDetailTrade.trade_type?.toUpperCase() || "TRADE"}
          </Tag>
        </div>

        <Text
          className={`trade-profit ${
            Number(
              selectedDetailTrade.profit?.$numberDecimal ??
              selectedDetailTrade.profit ??
              0
            ) >= 0
              ? "profit-positive"
              : "profit-negative"
          }`}
        >
          {formatCurrency(selectedDetailTrade.profit)}
        </Text>
      </div>

      <div className="trade-card-bottom">
        <Text className="trade-date">
          Opening Date:{" "}
          {selectedDetailTrade.opening_date
            ? moment.utc(selectedDetailTrade.opening_date).format("YYYY-MM-DD HH:mm")
            : "N/A"}
        </Text>
      </div>

      <Divider />

      <Descriptions column={1} size="small">
        <Descriptions.Item label="Trade ID">
          {selectedDetailTrade._id || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Symbol">
          {selectedDetailTrade.symbol || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Trade Type">
          {selectedDetailTrade.trade_type || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Segment">
          {selectedDetailTrade.segment || "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Quantity">
          {selectedDetailTrade.quantity ?? "N/A"}
        </Descriptions.Item>

        <Descriptions.Item label="Profit / Loss">
          {formatCurrency(selectedDetailTrade.profit)}
        </Descriptions.Item>

        <Descriptions.Item label="Strategy">
          {selectedDetailTrade.strategy_name ||
            selectedDetailTrade.strategy_id ||
            "Not assigned"}
        </Descriptions.Item>
      </Descriptions>

      <div className="trade-strategy-buttons">
        <button
          type="button"
          className="trade-strategy-btn trade-strategy-cancel"
          onClick={() => {
            setTradeDetailsOpen(false);
            setSelectedDetailTrade(null);
          }}
        >
          Close
        </button>

        <button
          type="button"
          className="trade-strategy-btn trade-strategy-assign"
          onClick={() => {
            const trade = selectedDetailTrade;
            setTradeDetailsOpen(false);
            openAssignStrategy(trade);
          }}
        >
          Assign Strategy
        </button>
      </div>
    </div>
  )}
 </GlassModal>
    </div>
  );
};

export default TradeLogsTradeTable;
